import React, { useState } from "react";
import logo from "../../Assets/Logos/Bharat Karigari N.png";
import { useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import SellerLoginModal from "../../components/Seller/SellerLoginModal";

const SellerNavbar = () => {
  const navigate = useNavigate();
  const [openLogin, setOpenLogin] = useState(false);

  return (
    <>
      <div className="bg-white sticky top-0 z-50">
        <div className="flex items-center justify-between px-4 md:px-10 py-1">
          <div
            onClick={() => navigate("/")}
            className="flex items-center gap-2 cursor-pointer"
          >
            <img src={logo} alt="Logo" className="h-12 w-auto" />
          </div>

          <div
            onClick={() => setOpenLogin(true)}
            className="flex items-center space-x-2 cursor-pointer"
          >
            <LogIn className="w-7 h-7" />
            <span className="font-philosopher text-xl">Login</span>
          </div>
        </div>
      </div>

      {openLogin && <SellerLoginModal closeModal={() => setOpenLogin(false)} />}
    </>
  );
};

export default SellerNavbar;
